<template>
  <section class="hero">
    <div class="container">
      <h1>Gigtrick - Get Your Gig</h1>
      <p>
        Ist dir dein Booking einen Kaffee wert?
      </p>
      <div class="cta">
        <a href="https://gigtrick.onepage.me/" class="btn primary">Start Now</a>
        <a href="#features" class="btn secondary">Learn More</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>
.hero {
  background: url('../assets/hero-background.jpg') no-repeat center center ;
 
   background-size: cover;
  height: 100vh; /* Full-screen height */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--text-color);
  padding: 0 1rem;
}

.container {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.9),
    rgba(0, 0, 0, 0.6)
  );
  padding: 4rem;
  border-radius: 10px;
}

@media (max-width: 768px) {

  
  .hero h1 {
    font-size: 2rem;
  }

  .hero p {
    font-size: 1rem;
  }

  .container {
    padding: 1rem;

  }
}


.hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--text-color);
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.hero .cta .btn {
  margin: 0.5rem;
}
</style>
